export enum BrandRouteSegment {
  Vw = 'vw',
  A = 'audi',
  C = 'vw'
}
